import { RootStateType } from "../redux/features/rootSlice";
import React from 'react'
import { useSelector } from "react-redux";

const useWebSocket = () => {
    const clientConfig = useSelector(
        (state: RootStateType) => state.configStateReducer.clientConfig
    );
    
    function updateUserAndNotifyParent(message: any) {
        const parentWindow = window.opener;
        if (parentWindow) {
            parentWindow.postMessage(message, clientConfig?.origin);
        }
    }

    return {
        updateUserAndNotifyParent
    }

}

export default useWebSocket
